export const TRANSLATIONS_JP_CHAT_TASKS_AND_PROFILE = {
  "tasks.process_document_a": "ドキュメントAを処理",
  "tasks.extract_entities_a": "ドキュメントAのエンティティ抽出",
  "tasks.classify_document_b": "ドキュメントBを分類",
  "tasks.classify_b_desc": "ドキュメントBの自動分類",
  "tasks.index_document_c": "ドキュメントCをインデックス",
  "tasks.index_c_desc": "検索用にドキュメントCをインデックス",
  "tasks.summarize_document_d": "ドキュメントDを要約",
  "tasks.summarize_d_desc": "自動要約生成",
  "chat.title": "ドキュメントアシスタント",
  "chat.grounding.evidence.aria": "根拠の状態",
  "chat.grounding.evidence.grounded": "文書に裏付けあり",
  "chat.grounding.evidence.partially_grounded": "部分的な裏付け",
  "chat.grounding.evidence.no_evidence": "文書の根拠なし",
  "chat.grounding.evidence.validation_failed": "根拠を検証できませんでした",
  "chat.grounding.evidence.retrieval_failed": "根拠を取得できませんでした",
  "chat.grounding.evidence.unknown": "根拠は不明",
  // 警告 (P2-1): `retrieval_failed` は `no_evidence` ではない — 障害で取得できなかったことと、
  // そもそも存在しないことは同じではない。文言を意図的に分けている。
  "chat.grounding.evidence.warning.partially_grounded": "この回答は利用可能な根拠の一部にのみ基づいており、不完全な可能性があります。金額や日付を利用する前に出典を確認してください。",
  "chat.grounding.evidence.warning.no_evidence": "この質問に対して文書を取得できませんでした。この回答はあなたの文書に裏付けられていません。",
  "chat.grounding.evidence.warning.validation_failed": "この回答が取得した文書と一致するかを検証できませんでした。金額や日付を利用する前に出典を確認してください。",
  "chat.grounding.evidence.warning.retrieval_failed": "システムエラーのため根拠を取得できませんでした。この回答はあなたの文書に裏付けられていません。もう一度お試しください。",
  "chat.generation.proposal.generateHere": "ここで生成",
  "chat.generation.enqueued": "要約を処理しています。進捗を見るにはこちらをクリックしてください。",
  "chat.generation.viewProgress": "生成ドキュメントで見る",
  "chat.generation.forbidden": "プランでは要約を生成できないか、上限に達しました。",
  "chat.generation.error": "生成をキューに追加できませんでした。",
  "chat.generation.proposal.button": "エグゼクティブサマリーを生成",
  "chat.generation.proposal.fallback": "あなたの書類からエグゼクティブサマリーを生成できます。作成しますか？",
  "chat.generation.generateSummary": "要約を生成",
  "chat.generation.defaultHint": "私のドキュメントのエグゼクティブサマリーを生成する",
  "chat.plus.menuLabel": "アクション",
  "chat.plus.modeSection": "検索タイプ",
  "chat.generation.candidatesQuestion": "要約用にこれらのドキュメントが見つかりました。これらで生成しますか？",
  "chat.generation.proposal.confirm": "はい、要約を生成",
  "chat.generation.proposal.adjust": "アシスタントで調整",
  "chat.generation.unnamedDoc": "ドキュメント",
  "chat.generation.armedPlaceholder": "生成したい要約を説明してください…",
  "chat.generation.armedCancel": "要約生成をキャンセル",
  "chat.placeholder": "メッセージを入力してください...",
  "chat.send": "送信",
  "chat.sources": "ソース",
  // `score` は retrieval のコサイン類似度であり、回答への信頼度ではない。
  "chat.relevance": "関連度",
  "chat.error.unsupportedQuestion": "申し訳ありません、質問の種類を理解できませんでした。もう少し文脈や詳細を教えていただけますか？",
  "chat.error.unexpected": "予期しないエラーが発生しました。",
  "chat.error.unknownResponse": "システムから不明な応答がありました。",
  "chat.download": "ダウンロード",
  "chat.feedback": "この回答は役に立ちましたか？",
  "chat.yes": "はい",
  "chat.no": "いいえ",
  "chat.feedback_comment": "コメントを追加（任意）",
  "chat.feedback_thanks": "フィードバックありがとうございます！",
  "chat.clear": "チャットをクリア",
  "chat.show_details": "詳細を表示",
  "chat.hide_details": "詳細を非表示",
  "chat.selected_source": "選択されたソース",
  "chat.location": "場所",
  "chat.chunk": "チャンク",
  "chat.typing": "入力中...",
  "chat.recover": "チャットを回復",
  "chat.new_session": "新しいセッションを開始",
  "chat.close": "チャットを閉じる",
  "chat.message_change_name_success": "チャット名が正しく更新されました",
  "chat.search_type": "検索タイプ",
  "chat.search_type.light": "軽い",
  "chat.search_type.default": "デフォルト",
  "chat.search_type.medium": "中",
  "chat.search_type.strong": "強い",
  "chat.input_placeholder": "何でも質問してください",
  "chat.edit_message": "メッセージを編集",
  "chat.edit": "編集",
  "chat.copy_message": "メッセージをコピー",
  "chat.like_message": "いいね",
  "chat.dislike_message": "よくない",
  "chat.deselect_message": "選択解除",
  "chat.copied": "コピー済み",
  "chat.download_document": "ドキュメントをダウンロード",
  "chat.documents": "ドキュメント",
  "chat.document": "ドキュメント",
  "chat.double_click_hint": "ダブルクリックで出典を表示",
  "chat.click_to_read_source": "クリックでこの出典を表示",
  "chat.fragment_text": "引用された抜粋",
  "chat.star_rating_title": "{{count}} つ星",
  "chat.downloaded": "ダウンロード完了",
  "chat.close_detail": "詳細を閉じる",
  "chat.session_name_empty_error": "名前は空にできません。",
  "chat.session_untitled": "名称未設定のセッション",
  "chat.rename": "名前を変更",
  "chat.save": "保存",
  "chat.cancel": "キャンセル",
  "chat.no_previous_sessions": "以前のセッションはありません。",
  "tasks.pending": "保留中のタスク",
  "tasks.processed": "処理済みタスク",
  "tasks.created": "作成されたタスク",
  "tasks.processed_at": "処理日時",
  "tasks.loading": "タスクを読み込み中...",
  "tasks.status": "ステータス",
  "tasks.step": "ステップ",
  "tasks.description": "説明",
  "tasks.created_by": "作成者",
  "tasks.no_processed": "処理済みタスクはありません。",
  "tasks.filters": "フィルター",
  "tasks.filter_by_id": "IDでフィルター",
  "tasks.filter_by_date": "日付でフィルター",
  "tasks.clear_filters": "フィルターをクリア",
  "tasks.no_pending": "保留中のタスクはありません。",
  "profile.name": "名前",
  "profile.email": "メール",
  "profile.company": "会社",
  "profile.role": "役割",
  "profile.title": "プロフィール",
  "profile.section_personal": "個人情報",
  "profile.section_organization": "組織",
  "profile.country": "国",
  "profile.country_select": "国を選択",
  "profile.section_preferences": "設定",
  "profile.email_managed": "システムによって管理されているメール",
  "profile.role_managed": "システムによって管理されている役割",
  "profile.job_title": "職名",
  "profile.organization_type": "組織の種類",
  "profile.organization_size": "組織の規模",
  "profile.loading": "プロフィールを読み込み中...",
  "profile.loading_data": "データを読み込み中...",
  "profile.save": "保存",
  "profile.save_success": "プロフィールが正常に保存されました。",
  "chat.inputmode_question": "ドキュメント情報の取得",
  "chat.inputmode_csv": "CSVクエリ",
  "chat.inputmode_db": "データベースクエリ",
  "chat.inputmode_count_documents": "ドキュメントの件数",
  "chat.no_sessions": "セッションはありません",
  "chat.tools": "ツール",
  "chat.expertRole.label": "次の役割で回答…",
  "chat.expertRole.placeholder": "役割なし",
  "chat.expertRole.clear": "専門家を解除",
  "chat.expertRole.applied": "次の役割で回答しました",
  "chat.expertRole.notEntitled": "ご利用のプランには専門家ロールが含まれていません",
  "chat.expertRole.degraded": "選択した役割はこの回答には適用されませんでした。",
  "chat.expertRole.messageBadge": "専門家への相談",
  "profile.change_photo": "写真を変更",
  "profile.name_required": "名前は必須です。",
  "profile.load_error": "プロフィールの読み込みエラー。",
  "profile.photo_upload_error": "写真のアップロードエラー。",
  "profile.save_error": "プロフィールの保存エラー。",
  "tasks.filter_by_status": "ステータスで絞り込み",
  "tasks.filter_by_user": "ユーザーで絞り込み",
  "tasks.filter_by_description": "説明で絞り込み",
};
